/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, HostBinding, Input } from '@angular/core';
import { cva, VariantProps } from 'class-variance-authority';

export const userProfileUnassignedVariants = cva('flex gap-1 items-center', {
  variants: {
    variant: {
      default: '',
      searchItem: 'py-1 px-3',
    },
  },
  defaultVariants: { variant: 'default' },
});

export type UserProfileUnassignedVariants = VariantProps<typeof userProfileUnassignedVariants>;

@Component({
  selector: 'alfa-user-profile-unassigned',
  standalone: false,
  templateUrl: './user-profile-unassigned.component.html',
})
export class UserProfileUnassignedComponent {
  @Input() variant: UserProfileUnassignedVariants['variant'];

  @HostBinding('class') get hostClasses() {
    return userProfileUnassignedVariants({ variant: this.variant });
  }
}
